import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper } from './style';
import { getDateTime } from '../../lib/dates';
import { ItemList } from '../Items/ItemList';
import { OrderGroupHeader } from './OrderGroupHeader';
import { store } from '../../store';

export const ItemOrderGroup = ({
  group,
  onClick,
  returnCart,
  readOnly,
  borderless,
  showCheckmark = true,
  headerDate = true,
}) => {
  const {
    order: {
      order_info: { order_date: orderDate, order_number: orderNumber },
    },
    items,
  } = group;

  const {
    page: { locale },
  } = store.getState();

  return (
    <Wrapper>
      <OrderGroupHeader
        title={orderNumber}
        subtitle={getDateTime({ date: orderDate, locale })}
        headerDate={headerDate}
      />
      <ItemList
        items={items}
        onClick={onClick}
        orderNumber={orderNumber}
        selected={returnCart.map((e) => e.item_id)}
        readOnly={readOnly}
        borderless={borderless}
        showCheckmark={showCheckmark}
      />
    </Wrapper>
  );
};

ItemOrderGroup.defaultProps = {
  onClick: () => {},
  returnCart: [],
  readOnly: false,
  borderless: false,
  showCheckmark: true,
  headerDate: true,
};

ItemOrderGroup.propTypes = {
  group: PropTypes.shape({
    order: PropTypes.shape({
      order_info: PropTypes.shape({
        order_date: PropTypes.string,
        order_number: PropTypes.string,
      }),
    }),
    items: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  onClick: PropTypes.func,
  returnCart: PropTypes.arrayOf(PropTypes.object),
  readOnly: PropTypes.bool,
  borderless: PropTypes.bool,
  showCheckmark: PropTypes.bool,
  headerDate: PropTypes.bool,
};
